const imports = [
    { selector: "#sb_doc_create", module: () => require('../doc/create/doc_create.js') },
    { selector: "#sb_doc_edit", module: () => require('../doc/edit/doc_edit.js') },
    { selector: "#sb_quest_block", module: () => require('../scheck/scheck.js') },
    { selector: "#sb_cameras", module: () => require('../cameras/edit_cameras.js') },
    { selector: "#sb_plombs", module: () => require('../plombs/create.js') },
    { selector: "#plomb_remover", module: () => require('../plombs/plomb_remover.js') },
    { selector: "#os_inside_skd", module: () => require('../uprox_status/os/os_inside_skd.js')},
    { selector: ".os_gw_imc", module: () => require('../uprox_status/uprox_card_status')},
];

imports.forEach(item => {
    if ($(item.selector).length > 0) {
        item.module();
    }
});
